import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { OrderStateToken } from '@sleed/bizcommerce-api';
import { orderStatesApi } from '~/lib/api/client';
import { formToToken, type OrderStateFormValues } from '~/lib/schemas/order-state';

export const orderStateKeys = {
	all: ['order-states'] as const,
	list: () => [...orderStateKeys.all, 'list'] as const
};

export function useOrderStatesList() {
	return useQuery<OrderStateToken[]>({
		queryKey: orderStateKeys.list(),
		queryFn: async () => (await orderStatesApi.getAll()).data.items ?? []
	});
}

export function useOrderStateMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: orderStateKeys.list() });
	const create = useMutation({
		mutationFn: async (form: OrderStateFormValues) => (await orderStatesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: OrderStateFormValues) => (await orderStatesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await orderStatesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
